import { Programming } from '../../models/programming';
import { isSpreadsheetTerminalStatus } from './programming-list-spreadsheet';

export const PROGRAMMING_EDIT_DENIED_TOOLTIP =
    'Sem permissão: só administrador, gestor do cliente ou quem criou a programação pode editar.';

export function canEditProgrammingRow(opts: {
    profile?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    managerClientId?: string | null;
    programming: Pick<Programming, 'clientId' | 'createdByUserId' | 'createdBy' | 'status'>;
}): boolean {
    const { profile, userId, userEmail, managerClientId, programming } = opts;

    if (isSpreadsheetTerminalStatus(programming.status))
        return false;

    if (profile === 'Admin')
        return true;

    if (profile !== 'Manager')
        return false;

    if (programming.createdByUserId && userId && programming.createdByUserId === userId)
        return true;

    if (programming.createdBy) {
        if (userEmail && programming.createdBy.toLowerCase() === userEmail.toLowerCase())
            return true;
        if (userId && programming.createdBy === userId)
            return true;
    }

    return Boolean(managerClientId && managerClientId === programming.clientId);
}
